(function() {
    const REDIRECT_PATH = '/account/logout'; 
    document.addEventListener('DOMContentLoaded', function() {
    const selector = '.shopify-challenge__button';
    const $button = document.querySelector(selector);
  
    if ($button) {
      $button.addEventListener('click', function(event) {
      setTimeout(function() {
        window.location.href = REDIRECT_PATH;
      }, 500);
      });
    }
    });
  })();